<app-pa-overall (onCheckDetailsClick)="handleOnCheckDetailsClick($event)"></app-pa-overall>